import ServiceBar from "./service-bar";
import SearchStatus from "./search-status";
import SearchHistory from "./search-history";
import DateControl from "./date-control";
import PageTitle from "./page-title";
const modul = angular
    .module("ServiceBarComponents", [])
    .directive("serviceBar", ServiceBar)
    .directive("searchStatus", SearchStatus)
    .directive("searchHistory", SearchHistory)
    .directive("dateControl", DateControl)
    .directive("pageTitle", PageTitle);

export default modul.name;
